import { defineStore } from 'pinia';
import { getAreaTree } from '@/api/open';

export const useDictionaryStore = defineStore({
  id: 'dictionary',
  state: () => ({
    provinceList: [],
  }),
  actions: {
    // 获取省市区
    async getProvince() {
      try {
        const res = await getAreaTree({
          t: Date.now(),
        });
        this.provinceList = res?.data || [];
      } catch (error) {
        // 获取省市区失败
        throw Error('获取省市区失败');
      }
    },
  },
});
